const getCssPropertyByNode = (node, propertyName) =>
  node.ownerDocument.defaultView.getComputedStyle(node).getPropertyValue(propertyName);

export default getCssPropertyByNode;
